<script setup lang="ts">
import { useBreadcrumbsAndJsonld } from "@/composables/useBreadcrumbsAndJsonld";

const { breadcrumbs } = useBreadcrumbsAndJsonld();
</script>

<template>
  <div class="breadcrumbs">
    <span v-for="(item, index) in breadcrumbs" :key="item.url">
      <span v-if="index !== breadcrumbs.length - 1">
        <a v-if="item.url" :href="item.url">{{ item.text }}</a>
        <span v-else>{{ item.text }}</span>
        ＞
      </span>
      <span v-else>{{ item.text }}</span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
/*---------------------------------------
.breadcrumbs
----------------------------------------*/
.breadcrumbs {
  border-top: 1px solid #dcdcdc;
  padding: 0.8em 4% 1.5em;
  font-size: 80%;
  line-height: 1.27;
  a {
    color: #2056a0;
  }
}

@media screen and (min-width: 751px) {
  .breadcrumbs {
    border-top: none;
    margin: 0 auto;
    padding: 11px 0 34px;
    width: 960px;
  }
}
</style>
